import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import Pagination from '@/components/Pagination.vue'
import { useRouter } from 'vue-router'
import { getCurrentInstance, reactive, onMounted, ref } from 'vue'
import { getStoreOrderListApi, getSaaSStoreOrderListApi } from '@/apis/order'
import { openRouteInNewWindow } from '@/utils/router-helper'

enum OrderStatus {
    '待支付',
    '已支付',
    '已完成',
    '已取消',
}

enum SaaSOrderStatus {
    '待支付' = 1,
    '出餐中',
    '出餐成功',
    '出餐失败',
    '配送中',
    '配送完成',
    '未支付自动取消',
}


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const router = useRouter()

const activeIndex = ref('1')
const filters = reactive({
    order_no: '',
    user_phone: '',
    contact_phone: '',
    order_status: '',

    order_code: '',
    channel_order_code: '',
    phone: '',
    status: '',

    page: 1,
    page_size: 10,
})

const tableData = ref([])
const total = ref(0)
const getList = async () => {
    var res
    if (activeIndex.value == '1') {
        res = await getStoreOrderListApi(filters) as any
    } else {
        res = await getSaaSStoreOrderListApi(filters) as any
    }

    const { code, data, msg } = res
    if (code != 200) return proxy.$message({ type: 'error', message: msg })
    tableData.value = data.data
    total.value = data.total
}

const onTabChange = (val) => {
    activeIndex.value = val
    
    filters.order_no = ''
    filters.user_phone = ''
    filters.contact_phone = ''
    filters.order_status = ''
    filters.page = 1
    getList()
}

const toDetail = (row) => {
    let path:string = '', query:any = {}
    if (activeIndex.value == '1') {
        path = '/order/store-edit'
        query.order_id = row.id
    } else {
        path = '/order/store-edit-saas'
        query.id = row.id
    }

    openRouteInNewWindow({
        path,
        query
    })
}
const search = () => {
    filters.page = 1
    getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}
onMounted(() => {
    getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (activeIndex.value == '1')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: filters.order_no,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.order_no) = $event)),
              modelModifiers: { trim: true },
              placeholder: "订单号",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: filters.user_phone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.user_phone) = $event)),
              modelModifiers: { trim: true },
              placeholder: "用户手机号",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: filters.contact_phone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.contact_phone) = $event)),
              modelModifiers: { trim: true },
              placeholder: "联系手机号",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_select, {
              class: "filter-item",
              modelValue: filters.order_status,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.order_status) = $event)),
              placeholder: "订单状态",
              clearable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "待支付",
                  value: 0
                }),
                _createVNode(_component_el_option, {
                  label: "已支付",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "已完成",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "已取消",
                  value: 3
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: filters.order_code,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.order_code) = $event)),
              modelModifiers: { trim: true },
              placeholder: "订单号",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: filters.channel_order_code,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.channel_order_code) = $event)),
              modelModifiers: { trim: true },
              placeholder: "渠道订单号",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              class: "filter-item",
              modelValue: filters.phone,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.phone) = $event)),
              modelModifiers: { trim: true },
              placeholder: "手机号",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_select, {
              class: "filter-item",
              modelValue: filters.status,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.status) = $event)),
              placeholder: "订单状态",
              clearable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "待支付",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "出餐中",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "出餐成功",
                  value: 3
                }),
                _createVNode(_component_el_option, {
                  label: "出餐失败",
                  value: 4
                }),
                _createVNode(_component_el_option, {
                  label: "配送中",
                  value: 5
                }),
                _createVNode(_component_el_option, {
                  label: "配送完成",
                  value: 6
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 64)),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_menu, {
      "default-active": activeIndex.value,
      class: "el-menu-demo",
      mode: "horizontal",
      onSelect: onTabChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "1" }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("平台订单")
          ])),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "2" }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode("Saas订单")
          ])),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["default-active"]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: "",
      class: "mt20"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "ID",
          width: "80"
        }),
        (activeIndex.value == '1')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_el_table_column, {
                prop: "order_no",
                label: "订单号"
              }),
              _createVNode(_component_el_table_column, { label: "用户手机号" }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.username?.length > 11 ? row.username.substring(0, 11) : row.username || '--'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "receiver_phone",
                label: "联系手机号"
              }),
              _createVNode(_component_el_table_column, {
                prop: "store_brand_name",
                label: "下单品牌"
              })
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_el_table_column, {
                prop: "order_code",
                label: "订单号"
              }),
              _createVNode(_component_el_table_column, {
                prop: "channel_order_code",
                label: "渠道订单号"
              }),
              _createVNode(_component_el_table_column, {
                prop: "channel_no",
                label: "渠道号",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "phone",
                label: "用户手机号"
              })
            ], 64)),
        _createVNode(_component_el_table_column, {
          prop: "store_name",
          label: "餐厅名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "total_amount",
          label: "总金额 "
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "下单时间",
          width: "145"
        }),
        _createVNode(_component_el_table_column, {
          prop: "paid_at",
          label: "支付时间",
          width: "145"
        }),
        _createVNode(_component_el_table_column, { label: "状态" }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(activeIndex.value == '1' ? OrderStatus[row.status] : SaaSOrderStatus[row.status]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "73"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (toDetail(row))
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"])
  ]))
}
}

})